import React, { useState, useEffect } from "react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { toast } from "react-toastify";
import axios from "axios";
import { buildApiUrl } from "../utils/api";

const ConstructorColumnas = () => {
  // Declaramos el estado para columnName
  const [columnName, setColumnName] = useState("");
  const [loading, setLoading] = useState(false);
  const [existingColumns, setExistingColumns] = useState([]);

  // Al montar, cargamos todas las columnas desde el endpoint /columns
  useEffect(() => {
    fetchAllColumns();
  }, []);

  // Función para cargar todas las columnas "globales"
  const fetchAllColumns = async () => {
    try {
      const response = await axios.get(buildApiUrl(`/columns`), {
        headers: { "X-WP-Nonce": autocrm_globals.nonce },
      });
      console.log("✅ Columnas recibidas:", response.data.columns);
      setExistingColumns(response.data.columns || []);
    } catch (error) {
      console.error("❌ Error al obtener columnas:", error);
      setExistingColumns([]);
    }
  };

  // Función para guardar una nueva columna (sin order_id)
  const handleSaveColumn = async () => {
    console.log("🟢 handleSaveColumn ejecutado. columnName:", columnName);

    // Validación para columnName
    if (!columnName.trim()) {
      toast.error("Por favor, ingresa un nombre de columna válido.");
      console.log("❌ Validación fallida: nombre de columna vacío");
      return;
    }

    if (!columnName.match(/^[a-zA-Z0-9_]+$/)) {
      toast.error("El nombre de la columna solo puede contener letras, números y guiones bajos.");
      console.log("❌ Validación fallida: caracteres no permitidos");
      return;
    }

    if (existingColumns.includes(columnName)) {
      toast.error("Esta columna ya existe.");
      console.log("❌ Validación fallida: columna duplicada");
      return;
    }

    setLoading(true);
    try {
      // Enviamos la nueva columna al endpoint /columns (POST)
      await axios.post(
        buildApiUrl("/columns"),
        {
          column_name: columnName,
          unique_key: "autocrm-global-columns" // 🟢 Aquí marcamos que es global
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-WP-Nonce": autocrm_globals.nonce,
          },
        }
      );

      toast.success("Columna agregada correctamente.");
      console.log("✅ Columna guardada correctamente");
      setColumnName("");
      await fetchAllColumns();
    } catch (error) {
      toast.error("Error al guardar la columna.");
      console.error("❌ Error al guardar la columna:", error);
    } finally {
      setLoading(false);
    }
  };

  // Función para eliminar una columna creada en el constructor
  const handleDeleteColumn = async (column) => {
    console.log("🗑️ handleDeleteColumn ejecutado con:", column);

    if (!window.confirm(`¿Seguro que deseas eliminar la columna "${column}"?`)) {
      console.log("❌ Eliminación cancelada");
      return;
    }

    setLoading(true);
    try {
      await axios.delete(buildApiUrl("/columns"), {
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": autocrm_globals.nonce,
        },
        data: { column_name: column },
      });

      toast.success("Columna eliminada correctamente.");
      console.log("✅ Columna eliminada correctamente");
      await fetchAllColumns();
    } catch (error) {
      toast.error("Error al eliminar la columna.");
      console.error("❌ Error al eliminar la columna:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="autocrm-card autocrm-card--max-width">
      <CardContent className="autocrm-card-content">
        <h2 className="autocrm-title">Constructor de Columnas (Global)</h2>

        {/* Input para Nombre de Columna */}
        <div className="autocrm-margin-bottom">
          <label className="autocrm-label">Nombre de la columna (único):</label>
          <Input
            type="text"
            value={columnName}
            onChange={(e) => setColumnName(e.target.value)}
            placeholder="metakey_en_minusculas_etc"
          />
        </div>

        {/* Lista de Columnas Existentes + Botón de Eliminación */}
        <div className="autocrm-margin-bottom">
          <h3 className="autocrm-subtitle">Columnas Disponibles:</h3>
          {existingColumns.length > 0 ? (
            <ul className="autocrm-list">
              {existingColumns.map((col, index) => (
                <li
                  key={index}
                  className="autocrm-list-item autocrm-flex autocrm-justify-between autocrm-items-center"
                >
                  <span className="autocrm-text-gray">{col}</span>
                  
                </li>
              ))}
            </ul>
          ) : (
            <p className="autocrm-text-gray">No hay columnas personalizadas.</p>
          )}
        </div>

        {/* Botón para Guardar Nueva Columna */}
        <Button
          onClick={handleSaveColumn}
          className="autocrm-btn autocrm-btn-full"
          disabled={loading}
        >
          {loading ? "Guardando..." : "Guardar Columna"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default ConstructorColumnas;
